import http from '@core/fetch'

export default {
  getListApi: body => http('/assets/data/list.json', { body }),
  getDetailsApi: () => http('/assets/data/info.json')
}
